import { UnorderedList, ListItem } from '@chakra-ui/react';
import * as types from 'types';
import { RequirementsSummary } from 'shared-components';
import { loanTypeLabel } from '../../../../organisms/finance/EducationSponsor/utils';

interface IProps {
  loanType?: string;
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = [
    '1.1',
    '1.2',
    '1.3',
    '2.1',
    '2.2',
    '3.1',
    '3.2',
    '3.3',
    '3.4',
    '3.5',
    '3.6',
    '3.7',
    '3.8',
    '4.1'
  ];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'1. We have to be sure your letter is authentic'}
        >
          {sectionsToShow.includes('1.1') || sectionsToShow.includes('1.2') || sectionsToShow.includes('1.3') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>
                  It is recommended that your letter is printed on official letter headed paper or stationery of the
                  loan provider
                </ListItem>
              ) : null}
              {sectionsToShow.includes('1.2') ? (
                <ListItem>The letterhead should include the name and logo of the loan provider</ListItem>
              ) : null}
              {sectionsToShow.includes('1.3') ? (
                <ListItem>
                  The letter should include a signature and the official stamp or seal of the loan provider (optional)
                </ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary uploadWarning={props.uploadComplete} title={'2. Your letter must have a valid date'}>
          <UnorderedList>
            {sectionsToShow.includes('2.1') ? <ListItem>The date must be no more than 6 months ago</ListItem> : null}
            {sectionsToShow.includes('2.2') ? (
              <ListItem>
                It is recommended that the date gives you enough time to use it for your visa application (optional)
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('3.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'3. The body text of the letter must state the intention and details of your loan provider'}
        >
          <UnorderedList>
            {sectionsToShow.includes('3.1') ? (
              <ListItem>
                The letter must specify your name to identify you as the recipient of the funds (matching passport)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('3.2') ? (
              <ListItem>The loan provider must be named and confirmed as the source of funds</ListItem>
            ) : null}
            {sectionsToShow.includes('3.3') ? (
              <ListItem>The name of the course as per your offer letter must be specified</ListItem>
            ) : null}
            {sectionsToShow.includes('3.4') ? (
              <ListItem>The amount in pounds or the percentage being covered</ListItem>
            ) : null}
            {sectionsToShow.includes('3.5') ? (
              <ListItem>
                The period the loan will be covering you for (should match your course start and end date)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('3.6') ? (
              <ListItem>That the loan is: {props.loanType ? loanTypeLabel(props.loanType) : ''}</ListItem>
            ) : null}
            {sectionsToShow.includes('3.7') ? (
              props.loanType === types.LoanType.NATIONAL_GOV ? (
                <ListItem>The funds will be released either before departure or on arrival to the UK</ListItem>
              ) : (
                <ListItem>
                  The funds will be released to the applicant before travel or the funds will be paid directly to the
                  university
                </ListItem>
              )
            ) : null}
            {sectionsToShow.includes('3.8') ? (
              <ListItem>
                There must be no conditions on the loan (other than a successful Student visa application, the letter is
                valid if this is stated)
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('4.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'4. We may need to contact your loan provider'}
        >
          <UnorderedList>
            {sectionsToShow.includes('4.1') ? (
              <ListItem>
                Please ensure contact details are included in the letterhead or the body of the letter
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}
    </>
  );
}
